// extracted by mini-css-extract-plugin
export default {"title":"HomePage_title__ygULj"};